import type { PrivateStackNavigationProps } from '@south-street-app/navigation/types';

import { ScreenWrapper } from '@south-street-app/molecules';
import { useChatStore } from '@south-street-app/stores';

import { ArchivedConversationContent } from './ArchivedConversationContent';

type ArchivedChatScreenProps = PrivateStackNavigationProps<'ArchivedChatScreen'>;

const ArchivedChatScreen = ({ route }: ArchivedChatScreenProps) => {
  const conversation = useChatStore((state) =>
    state.archivedConversations.find(
      (archivedConversation) =>
        archivedConversation.uniqueName === route.params.uniqueName,
    ),
  );

  return (
    <ScreenWrapper>
      <ArchivedConversationContent conversation={conversation ?? null} />
    </ScreenWrapper>
  );
};

export { ArchivedChatScreen };
